import { dew as _eqDew } from "./eq";
import { dew as _neqDew } from "./neq";
import { dew as _gtDew } from "./gt";
import { dew as _gteDew } from "./gte";
import { dew as _ltDew } from "./lt";
import { dew as _lteDew } from "./lte";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  const eq = _eqDew();
  const neq = _neqDew();
  const gt = _gtDew();
  const gte = _gteDew();
  const lt = _ltDew();
  const lte = _lteDew();
  const cmp = (a, op, b, loose) => {
    switch (op) {
      case "===":
        if (typeof a === "object") {
          a = a.version;
        }
        if (typeof b === "object") {
          b = b.version;
        }
        return a === b;
      case "!==":
        if (typeof a === "object") {
          a = a.version;
        }
        if (typeof b === "object") {
          b = b.version;
        }
        return a !== b;
      case "":
      case "=":
      case "==":
        return eq(a, b, loose);
      case "!=":
        return neq(a, b, loose);
      case ">":
        return gt(a, b, loose);
      case ">=":
        return gte(a, b, loose);
      case "<":
        return lt(a, b, loose);
      case "<=":
        return lte(a, b, loose);
      default:
        throw new TypeError(`Invalid operator: ${op}`);
    }
  };
  exports = cmp;
  return exports;
}